<template>
    <rkm-form
        v-if="model"
        ref="Form"
        show-legend
    >
        <rkm-row>
            <rkm-col>
                <rkm-form-select
                    :options="form.unidadeSolicitante"
                    :validations="validations.infraestruturaSolicitanteId"
                    label="Unidade solicitante"
                    show-default-option
                    text-field="nomeFantasia"
                    v-model="model.infraestruturaSolicitanteId"
                    value-field="id"
                />
            </rkm-col>

            <rkm-col>
                <rkm-form-input-autocomplete
                    :repository="repositories.usuario"
                    :requestQueryStringParams="{
                        infraestrutura_id: model.infraestruturaSolicitanteId,
                    }"
                    :searchFields="fields.autocomplete.usuarioSolicitante"
                    :text-field="u => `${u.cidadaoNome}`"
                    :validations="validations.usuarioSolicitante"
                    label="Profissional responsável"
                    placeholder="Digite o nome do profissional"
                    uppercase
                    v-model="model.usuarioSolicitante"
                    value="id"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <rkm-form-select
                    :disabled="checkTravaCampos()"
                    :options="form.grupo"
                    :validations="validations.grupoId"
                    label="Grupo"
                    show-default-option
                    text-field="nome"
                    v-model="model.grupoId"
                    value-field="id"
                />
            </rkm-col>

            <rkm-col>
                <rkm-form-select
                    :disabled="checkTravaCampos()"
                    :options="form.subGrupo"
                    :validations="validations.subGrupoId"
                    label="Subgrupo"
                    show-default-option
                    text-field="nome"
                    v-model="model.subGrupoId"
                    value-field="id"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <rkm-form-select
                    :disabled="checkTravaCampos()"
                    :options="form.servico"
                    :validations="validations.servicoId"
                    label="Serviço"
                    show-default-option
                    text-field="nome"
                    v-model="model.servicoId"
                    value-field="id"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row  class="flex-nowrap">
            <rkm-col>
                <rkm-form-select
                    :options="form.causaProvavel"
                    label="Causa provável"
                    show-default-option
                    text-field="nome"
                    v-model="model.causaProvavelId"
                    value-field="id"
                />
            </rkm-col>

            <rkm-col class="col-auto d-flex justify-content-end">
                <rkm-button
                    :disabled="!model.causaProvavelId"
                    :label="false"
                    @click="handleCausaProvavelAdd()"
                    class="buttons"
                    color="primary"
                >
                    Incluir
                </rkm-button>
            </rkm-col>
        </rkm-row>

        <causaProvavelList
            :data="model.causaProvavelLista"
            @openModalObservacoes="handleOpenModal"
            ref="CausaProvavelLista"
        />

        <causaProvavelListObservacao
            :data="model.causaProvavelLista"
            ref="ModalOberservacao"
        />

        <rkm-row class="space-up">
            <rkm-col>
                <rkm-form-textarea
                    :validations="validations.assunto"
                    label="Resumo da solicitação/assunto"
                    uppercase
                    v-model="model.assunto"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <rkm-form-textarea
                    :validations="validations.detalhe"
                    label="Detalhes da solicitação"
                    uppercase
                    v-model="model.detalhe"
                />
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>

// Components.
import causaProvavelList from './components/causa-provavel/List'
import CausaProvavelListObservacao from './components/causa-provavel/Modal'

// Vuex.
import { mapActions } from 'vuex'

// Mixins.
import { repository, stringCase, object, error, file } from '@/mixins'

export default {
    components: { causaProvavelList, CausaProvavelListObservacao },
    computed: {
        validations() {

            return {
                infraestruturaSolicitanteId: {
                    required: true,
                },
                usuarioSolicitante: {
                    required: true,
                },
                grupoId: {
                    required: true,
                },
                subGrupoId: {
                    required: true,
                },
                servicoId: {
                    required: true,
                },
                assunto: {
                    min: 3,
                    max: 150,
                },
                detalhe: {
                    min: 3,
                    max: 1000,
                }
            }
        },
        fields() {
            return {
                autocomplete: {
                    usuarioSolicitante: [
                        { key: 'cadastro_cidadao.nome', searchable: true },
                    ],
                },
            }
        },
    },
    created() {

        this.repositories = {
            solicitacao: this.getConectaSusRepository('manutencao.solicitacao'),
            usuario: this.getConectaSusRepository('cadastro.sujeitoAtencao.usuario'),
            impressao: this.getConectaSusRepository('impressao.manutencao'),
        }

        this.load()
    },
    data: () => ({
        model: null,
        form: null,
        previousGrupoId: null,
        previousSubGrupoId: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.$nextTick().then(() => {
                this.setLoading()

                if (this.id) {

                    this.repositories.solicitacao.edit(this.id)
                        .then(({ data }) => {

                            if (data.model && data.form) {

                                this.model = this.clone(data.model)
                                this.form = this.clone(data.form)
                                this.previousGrupoId = this.model.grupoId
                                this.previousSubGrupoId = this.model.subGrupoId
                                this.causaProvavelLista = this.model.causaProvavelLista
                            }
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())

                } else {

                    this.repositories.solicitacao.create()
                        .then(({ data }) => {

                            if (data.model && data.form) {

                                this.model = this.clone(data.model)
                                this.form = this.clone(data.form)
                            }
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                }
            })
        },
        handleGrupoChange() {

            if (this.model.grupoId !== this.previousGrupoId) {

                const params = this.model.grupoId;

                this.model.servicoId = null;
                this.model.causaProvavelId = null;

                this.repositories.solicitacao.list({ listar: 'subGrupo', params })
                    .then(response => {

                        this.form.subGrupo = response.data;
                    })
                    .catch(this.handleError);

                if (this.previousGrupoId !== null) {

                    this.model.subGrupoId = null;
                }

                this.previousGrupoId = this.model.grupoId;
            }
        },
        handleSubGrupoChange() {

            if (this.model.subGrupoId !== this.previousSubGrupoId) {

                const params = this.model.subGrupoId;

                this.model.servicoId = null;
                this.model.causaProvavelId = null;

                this.repositories.solicitacao.list({ listar: 'servico', params })
                    .then(response => {

                        this.form.servico = response.data;
                    })
                    .catch(this.handleError);

                if (this.previousSubGrupoId !== null) {

                    this.model.servicoId = null;
                }

                this.previousSubGrupoId = this.model.subGrupoId;
            }
        },
        handleServicoChange() {

            const params = this.model.servicoId;

            this.model.causaProvavelId = null;

            this.repositories.solicitacao.list({ listar: 'causaProvavel', params })
                .then(response => {

                    this.form.causaProvavel = response.data;
                })
                .catch(this.handleError);
        },
        handleCausaProvavelAdd() {

            const checkCausaProvavel = this.model.causaProvavelLista.find(
                causaProvavelLista => causaProvavelLista.id === this.model.causaProvavelId
            );

            if (checkCausaProvavel) {

                this.showValidationNotification('Causa provável já adicionada')
                this.model.causaProvavelId = null
                return
            }

            const causaProvavel = this.form.causaProvavel.find(causaProvavel => causaProvavel.id === this.model.causaProvavelId);

            if (causaProvavel) {

                if (!this.model.causaProvavel) {

                    this.model.causaProvavel = [];
                }

                this.model.causaProvavelLista.push(causaProvavel);
                this.model.causaProvavelId = null;
            }
        },
        checkTravaCampos() {

            if (this.causaProvavelLista) {

                return this.causaProvavelLista.length > 0;
            }
        },
        handleOpenModal(causaProvavel) {

            const index = this.model.causaProvavelLista.indexOf(causaProvavel)

            this.$refs.ModalOberservacao.open(index)
        },
        async print(id) {

            await new Promise(resolve => {
                this.showConfirmation(
                    'Deseja imprimir a solicitação?',
                    async () => {
                        await this.confirmPrint(id);
                        resolve();
                    },
                    async () => {
                        resolve();
                    }
                );
            });
        },
        confirmPrint(id) {

            this.setLoading();

            this.repositories.impressao.solicitacao(id)
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        save() {

            this.$refs.Form.validate()
                .then(async valid => {

                    if (!valid) return

                    this.setLoading()

                    try {
                        const request = this.id
                            ? this.repositories.solicitacao.update(this.id, this.prepareData())
                            : this.repositories.solicitacao.store(this.prepareData())

                        const { data } = await request

                        this.unsetLoading();

                        await this.print(data.id);
                        this.showSaveNotification()
                        this.$emit('save', data)
                    } catch (error) {
                        this.handleError(error)
                    } finally {
                        this.unsetLoading()
                    }
                })
        },
        prepareData() {

            if (this.model.usuarioSolicitante) {
                this.model.usuarioSolicitanteId = this.model.usuarioSolicitante.id ?? this.model.usuarioSolicitanteId;
                delete this.model.usuarioSolicitante;
            }
            return this.camelObjectKeysToSnakeRecursive(this.model);
        },
    },
    mixins: [ repository, stringCase, object, error, file ],
    props: {
        id: { type: Number },
    },
    watch: {
        'model.grupoId': function() {

            this.handleGrupoChange();
        },
        'model.subGrupoId': function() {

            this.handleSubGrupoChange();
        },
        'model.servicoId': function() {

            this.handleServicoChange();
        },
    }
}
</script>

<style scoped>
    .space-up {
        margin-top: 15px;
    }
</style>